import { gql } from "_graphql-types-frontend/gql";

export const ADD_DOCUMENT_QUEUE_SIGNED_URI = gql(`
  mutation addDocumentQueueSignedURI($names: [String!]!) {
    addDocumentQueueSignedURI(names: $names) {
      url
      documentQueueId: id
    }
  }
`);

export const GET_DOCUMENT_QUEUES_BY_IDS = gql(`
  query getDocumentQueuesByIds($ids: [ID!]!) {
    documentQueueMany(ids: $ids) {
      id
      name
      queueDate
      documentsId
      hash
      llmEntityId
      llmEntityNotes
      llmEntityTypeId
      llmEntityTypeNotes
      llmAsOfDate
      llmAsOfDateNotes
      llmDocumentTypeEnumId
      llmDocumentTypeEnumNotes
      llmProcessedAt
      duplicateDocuments {
        id
        name
        date
      }
    }
  }
`);

export const PROCESS_DOCUMENT_QUEUE = gql(`
  mutation processDocumentQueue($documentQueueId: ID!) {
    processDocumentQueue(documentQueueId: $documentQueueId)
  }
`);

export const PUBLISH_DOCUMENT_QUEUE = gql(`
  mutation publishDocumentQueues($input: [DocumentQueuePublishInput!]!) {
    publishDocumentQueues(input: $input) {
      documentQueueId
      success
      documentId
      documentName
      error
    }
  }
`);

export const GET_BUSINESS_OBJECT_ENUMS = gql(`
  query getBusinessObjectEnums($filter: BusinessObjectEnumFilter) {
    businessObjectEnumList(filter: $filter) {
      items {
        id
        name
      }
    }
  }
`);

export const GET_DOCUMENT_ACCESS_LEVELS = gql(`
  query getDocumentAccessLevels($filter: DocumentAccessLevelFilter) {
    documentAccessLevelList(filter: $filter) {
      items {
        id
        name
      }
    }
  }
`);

export const GET_DOCUMENT_TYPE_ENUMS = gql(`
  query getDocumentTypeEnums($filter: DocumentTypeEnumFilter) {
    documentTypeEnumList(filter: $filter, sort: [{field: name, order: ASC}]) {
      items {
        id
        name
      }
    }
  }
`);

export const DELETE_DOCUMENT_QUEUE = gql(`
  mutation deleteDocumentQueue($id: ID!) {
    deleteDocumentQueue(id: $id)
  }
`);

export const GET_DOCUMENT_AUTH_GROUPS = gql(`
query getDocumentAuthGroups($organizationId: Int!) {
    userList(filter: {
      organizationId: $organizationId,
      groupEntityType: document
    }) {
      items {
        id
        commonName
        organizationId
        userName
      }
    }
  }
`);

export const GET_KNOWLEDGE_BASE_TAGS = gql(`
  query getKnowledgeBaseTags($filter: KnowledgeBaseTagsFilter) {
    knowledgeBaseTagsList(filter: $filter, sort: [{field: id, order: ASC}]) {
      items {
        id
        name
        description
      }
    }
  }
`);

export const ADD_KNOWLEDGE_BASE_TAG = gql(`
  mutation addKnowledgeBaseTag($input: KnowledgeBaseTagsInput!) {
    addKnowledgeBaseTags(input: $input) {
      id
      name
      description
    }
  }
`);
